import React,{useState,useEffect} from "react";
import PropTypes from 'prop-types';
import {Blogs, Contact, Podcasts, Store} from "..";

export const NavigationDark = (props)=>{
	const [active, setActive] = useState(props.params.page)
	const [id, setId] = useState(props.params.id);

	useEffect(()=>{
		setActive(props.params.page)
	},[props.params.page])

	useEffect(()=>{
		setId(props.params.id)
	},[props.params.id])
	const  checkActive = (props)=>{
		if(props===active){
			return 'active'
		}else if(active !=="" && active !==undefined && active !== props){
			return 'inactive';
		}else{
			return  '';
		}
	}
	const  handleTabs=(props)=>{

		if(props===active && id !=='' && id !==undefined ){
      if (props==='podcasts'){
        setId("")
        window.history.pushState({}, null, "/dark/podcasts");
      }else if(props==='blog'){
        setId("")
        window.history.pushState({}, null, "/dark/blog");
      }else if(props==='contact'){
        setId("")
        window.history.pushState({}, null, "/dark/contact");
      }else if(props==='store'){
        setId("")
        window.history.pushState({}, null, "/dark/store");
      }else{
        window.history.pushState({}, null, "/dark");
      }
			setActive(props);
		}else if(props === active && (id==='' || id===undefined || id===-1)){
			setActive('')
			window.history.pushState({}, null, "/dark");

		}else{
			window.history.pushState({}, null, "/dark/"+props);
			setActive(props)
			setId('')
		}
	}
	return (
		<>
      <ul className="navigation">
        <Podcasts id={id?id:""}   page={active} checkActive={(e)=>checkActive(e)} handleTabs={(e)=>handleTabs(e)} onSelectItem={e=>{
          if(id===e){
            window.history.pushState({}, null, "/dark/podcasts");
            setId("")
          }else{
            window.history.pushState({}, null, "/dark/podcasts/"+e);
            setId(e)
          }
          setActive("podcasts")
        }}/>
        <Store id={id?id:""}  page={active} checkActive={(e)=>checkActive(e)} handleTabs={(e)=>handleTabs(e)} onSelectItem={e=>{
          if(id===e){
            window.history.pushState({}, null, "/dark/store");
            setId("")
          }else{
            window.history.pushState({}, null, "/dark/store/"+e);
            setId(e)
          }
          setActive("store")
        }}/>
       {/* <Blogs  id={id?id:""} page={active} checkActive={(e)=>checkActive(e)} handleTabs={(e)=>handleTabs(e)} onSelectItem={e=>{
            if(id===e){
              window.history.pushState({}, null, "/dark/blog");
              setId("")
            }else{
              window.history.pushState({}, null, "/dark/blog/"+e);
              setId(e)
            }
            setActive("blog")
          }}/>*/}
        <Contact  id={id?id:""} page={active} checkActive={(e)=>checkActive(e)} handleTabs={(e)=>handleTabs(e)} onSelectItem={e=>{
            if(id===e){
              window.history.pushState({}, null, "/dark/contact");
              setId("")
            }else{
              window.history.pushState({}, null, "/dark/contact/"+e);
              setId(e)
            }
            setActive("contact")
          }}/>

      </ul>
    </>
	)
}

NavigationDark.propTypes={
	params: PropTypes.object
}
NavigationDark.defaultProps={
	params:{
		page:'',
		id:''
	}
}
